export const COMMENT_TYPE = {
  DEFALUT: 'default',
  BATTLE: 'battle',
  DEIVIDER: 'divider',
  SURVEY: 'survey',
  ITEM: 'item',
  GM: 'gm',
} as const;

export type COMMENT_TYPE_KEY = keyof typeof COMMENT_TYPE;
export type COMMENT_TYPE_VALUE = typeof COMMENT_TYPE[COMMENT_TYPE_KEY];

export const COMMENT_TYPE_MAP = {
  [COMMENT_TYPE.DEFALUT]: '대화',
  [COMMENT_TYPE.DEIVIDER]: '구분선',
  [COMMENT_TYPE.BATTLE]: '배틀',
  [COMMENT_TYPE.SURVEY]: '조사',
  [COMMENT_TYPE.ITEM]: '아이템 조합',
  [COMMENT_TYPE.GM]: 'GM말하기',
};

export const selectedCommentTypeList = [
  {
    key: COMMENT_TYPE.DEFALUT,
    value: COMMENT_TYPE_MAP[COMMENT_TYPE.DEFALUT],
  },
  {
    key: COMMENT_TYPE.DEIVIDER,
    value: COMMENT_TYPE_MAP[COMMENT_TYPE.DEIVIDER],
  },
  {
    key: COMMENT_TYPE.BATTLE,
    value: COMMENT_TYPE_MAP[COMMENT_TYPE.BATTLE],
  },
];
